module.exports = __webpack_public_path__ + "static/img/8.f7bc3cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/8.png
// module id = 253
// module chunks = 0